import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons';

const MultiSelect = ({ 
  options = [], 
  value = [], 
  onChange, 
  placeholder = "Selecione...", 
  className = "",
  name = ""
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggleOption = (optionValue) => {
    // Garantir que value é sempre um array
    const safeValue = Array.isArray(value) ? value : [];
    const newValue = safeValue.includes(optionValue)
      ? safeValue.filter(v => v !== optionValue)
      : [...safeValue, optionValue];
    
    onChange(newValue);
  };

  const handleRemoveOption = (optionValue, e) => {
    e.stopPropagation();
    // Garantir que value é sempre um array
    const safeValue = Array.isArray(value) ? value : [];
    const newValue = safeValue.filter(v => v !== optionValue);
    onChange(newValue);
  };

  const getSelectedLabels = () => {
    // Garantir que value é sempre um array
    const safeValue = Array.isArray(value) ? value : [];
    return safeValue.map(val => {
      const option = options.find(opt => opt.value === val);
      return option ? option.label : val;
    });
  };

  const selectedLabels = getSelectedLabels();

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <div
        className="px-2 py-1 rounded border border-gray-300 focus-within:ring-2 focus-within:ring-green-400 cursor-pointer bg-white min-h-[2.25rem] flex items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex-1 flex flex-wrap gap-1">
          {selectedLabels.length === 0 ? (
            <span className="text-gray-500">{placeholder}</span>
          ) : (
            selectedLabels.map((label, index) => {
              const safeValue = Array.isArray(value) ? value : [];
              const optionValue = safeValue[index];
              return (
                <span
                  key={index}
                  className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-green-100 text-green-800"
                >
                  {label}
                  <button
                    type="button"
                    className="flex-shrink-0 ml-1 h-4 w-4 inline-flex items-center justify-center text-green-400 hover:bg-green-200 hover:text-green-500 focus:outline-none focus:bg-green-500 focus:text-white rounded-full"
                    onClick={(e) => handleRemoveOption(optionValue, e)}
                  >
                    <FontAwesomeIcon icon={faTimes} className="h-2 w-2" />
                  </button>
                </span>
              );
            })
          )}
        </div>
        <FontAwesomeIcon 
          icon={faChevronDown} 
          className={`w-4 h-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
        />
      </div>

      {isOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none">
          {options.length === 0 ? (
            <div className="px-4 py-2 text-sm text-gray-500">Nenhuma opção disponível</div>
          ) : (
            options.map((option) => {
              const safeValue = Array.isArray(value) ? value : [];
              return (
                <div
                  key={option.value}
                  className={`cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-green-50 ${
                    safeValue.includes(option.value) ? 'bg-green-100 text-green-900' : 'text-gray-900'
                  }`}
                  onClick={() => handleToggleOption(option.value)}
                >
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                      checked={safeValue.includes(option.value)}
                      onChange={() => {}} // Controlado pelo onClick do div
                    />
                    <span className="ml-3 block truncate font-normal">
                      {option.label}
                    </span>
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
